"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PNGDecoder_1 = __importDefault(require("./PNGDecoder"));
const PNGEncoder_1 = __importDefault(require("./PNGEncoder"));
function decodePNG(data, options) {
    const decoder = new PNGDecoder_1.default(data, options);
    return decoder.decode();
}
exports.decode = decodePNG;
function encodePNG(png, options) {
    const encoder = new PNGEncoder_1.default(png, options);
    return encoder.encode();
}
exports.encode = encodePNG;
//# sourceMappingURL=index.js.map